import { SettingsIcon } from "@icons";
import { permissionTypes } from "hooks/usePermissions";
import l from "@loadable/component";

const content = l(() => import("containers/Admin/outreachTemplates"));

const { PLATFORM_CONFIGURATION } = permissionTypes;

export default {
  key: "outreach-templates",
  title: "Outreach Templates",
  path: "/outreach-templates/:templateId?",
  basePath: "outreach-templates",
  requiredParams: [],
  optionalParams: ["templateId"],
  linkTarget: "/outreach-templates",
  linkTitle: "Outreach Templates",
  linkCategory: "Admin",
  icon: SettingsIcon,
  content,
  permission: [PLATFORM_CONFIGURATION],
};
